import request from '@/util/request'

export function alarmDuration(data){
  return request({
    url: '/iot/logs/alarmDuration',
    method: 'post',
    data: data
  })
}

// 查询实时数据列表
export function listTime(query) {
  return request({
    url: '/iot/analysis/time/list',
    method: 'get',
    params: query
  })
}

// 查询实时数据详细
export function getTime(id) {
  return request({
    url: '/iot/analysis/time/' + id,
    method: 'get'
  })
}

// 新增实时数据
export function addTime(data) {
  return request({
    url: '/iot/analysis/time',
    method: 'post',
    data: data
  })
}

// 修改实时数据
export function updateTime(data) {
  return request({
    url: '/iot/analysis/time',
    method: 'put',
    data: data
  })
}

// 删除实时数据
export function delTime(id) {
  return request({
    url: '/iot/analysis/time/' + id,
    method: 'delete'
  })
}

// 实时数据站点数据
export function siteDate(data){
	return request({
		url: '/iot/analysis/time/selectRealTimeStatistics',
		method: 'post',
		data: data
	})
}
//查询实时数据图表数据
export function timeChart(data){
	return request({
		url: '/iot/analysis/time/selectRealTimeChart',
		method: 'post',
		data: data
	})
}
